/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { getBoxShadowStyle } from '@styles/shadow';
import TouchableElement from '@components/common/touchableElement';
import EditableLine from '@components/common/editableLine';
import Header from '@components/settings/v2/common/SettingsHeader';
import { BACK_BUTTON_SETTINGS_TEXT, SCREEN_BORDER_RADIUS, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';

import { useManageMachineConnection } from './hooks/useManageMachineConnection';

const CheckLine = ({ array, onPress, selected, C }) => {
  return array.map((item, index) => {
    const firstIndex = index === 0;
    const lastIndex = index === array.length - 1;
    return (
      <View key={item.name} style={{ width: '100%' }}>
        <TouchableElement onPress={() => onPress(item)}>
          {({ pressHoverColor, boxStyle }) => (
            <View
              style={[
                boxStyle,
                {
                  paddingLeft: scale(15),
                  backgroundColor: C(pressHoverColor('Background / Light / Field')),
                },
                firstIndex && {
                  borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                  borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
                },
                lastIndex && {
                  borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
                  borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
                },
              ]}
            >
              <View
                style={[
                  !firstIndex && {
                    borderTopColor: C('Hairline / Light / No trans'),
                    borderTopWidth: StyleSheet.hairlineWidth,
                  },
                  {
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    height: scale(46),
                    width: '100%',
                  },
                ]}
              >
                <Text style={[font['Body'], { color: C('Label/Light/Primary') }]}>{i18n.t(item.name)}</Text>

                <View
                  style={{
                    justifyContent: 'center',
                    width: scale(19),
                    marginRight: scale(12),
                    opacity: selected === item.value ? 1 : 0,
                  }}
                >
                  <Svg icon="check" color="Link/Light/Primary" width={scale(19)} height={scale(19)} />
                </View>
              </View>
            </View>
          )}
        </TouchableElement>
      </View>
    );
  });
};

const MachineConnection = ({ C }) => {
  const {
    loading,
    connectionOptions,
    connectionMethodIsAutomatic,
    machineBrandCode,
    connectionMethodCode,
    allowNcFileTransfer,
    machineBrandList,
    connectionMethod,
    showBrandList,
    showProtocolList,
    updateData,
    save,
  } = useManageMachineConnection();

  const shadowStyles = getBoxShadowStyle({ type: 'Field', C });

  return (
    <View key="mainMachineContent" style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <Header backBtnText={BACK_BUTTON_SETTINGS_TEXT} name={'MachineConnection'} action={save} actionLoading={loading} />
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
        <View
          style={{
            width: '100%',
            paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
          }}
        >
          <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
            <CheckLine
              {...{
                array: connectionOptions,
                onPress: (item) => updateData('connectionMethodIsAutomatic', item.value),
                selected: connectionMethodIsAutomatic,
                C,
              }}
            />
          </View>

          {showBrandList && (
            <View>
              <View style={{ paddingHorizontal: scale(15), marginTop: scale(28) }}>
                <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('SELECT MACHINE CONTROL')}</Text>
              </View>
              <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS), marginTop: scale(5) }]}>
                <CheckLine
                  {...{ array: machineBrandList, onPress: (item) => updateData('machineBrandCode', item.value), selected: machineBrandCode, C }}
                />
              </View>
            </View>
          )}

          {showProtocolList && (
            <View>
              <View style={{ paddingHorizontal: scale(15), marginTop: scale(28) }}>
                <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('SELECT COMMUNICATION PROTOCOL')}</Text>
              </View>
              <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS), marginTop: scale(5) }]}>
                <CheckLine
                  {...{
                    array: connectionMethod[machineBrandCode],
                    onPress: (item) => updateData('connectionMethodCode', item.value),
                    selected: connectionMethodCode,
                    C,
                  }}
                />
              </View>
            </View>
          )}
          <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS), marginTop: scale(30) }]}>
            <EditableLine
              {...{
                item: {
                  value: allowNcFileTransfer,
                  key: 'switchedOn',
                  name: 'Download NC Files',
                  noArrow: true,
                  isLable: true,
                  oneLine: true,
                  small: false,
                  width: 220,
                  type: 'boolean',
                  onChange: (v) => {
                    updateData('allowNcFileTransfer', v);
                  },
                },
                index: 0,
                array: [{}],
                C,
                topBorder: false,
                bottomBorder: false,
                roundTop: true,
                roundBottom: true,
              }}
            />
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

export default ColorWrapper(MachineConnection);
